import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Entity, EntityUpdate } from "@/model";
import entityRepository from "@/repository/entityRepository";
import { entityQueryKeys } from "./keys";


export const useUpdateEntity = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Entity, AxiosError, EntityUpdate>({
        mutationKey: ["entity", "update", agentId],
        mutationFn: async (body: EntityUpdate) => {
            try {
                const { data } = await entityRepository.update(body);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.recent(agentId),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.pageAll(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.read(agentId, variables.entity_id)
            });
        }
    });
};
